<div class="cw-layout">
  <app-workbench-header [mode]="mode" [resourceCompanyId]="job?.companyId ?? null"></app-workbench-header>
  <main class="cw-layout__main" aria-labelledby="closedown-title">
    <header class="cw-page-head">
      <div>
        <nav class="cw-breadcrumb" [attr.aria-label]="'open_job_detail_job_details' | translate">
          @if (isTechnician) {
            <a routerLink="/siteinductioncompleted">{{ "open_job_detail_return_visit" | translate }}</a>
          } @else if (isApproval) {
            <a routerLink="/pendingapprovaljobs/summary">{{ "pending_approval_jobs_title" | translate }}</a>
            <span aria-hidden="true">/</span>
            <a [routerLink]="['/pendingapprovaljob/list']"
              [queryParams]="{ siteId: siteId, siteName: siteName, jobType: pendingJobListType }">
              {{ siteName || ("open_jobs_summary_unknown_site" | translate) }} -
              {{ (pendingJobListType === 'PPM' ? 'pending_approval_list_ppm' : 'pending_approval_list_jobs') | translate }}
            </a>
          } @else {
          <a routerLink="/openjobs">{{ "open_jobs_summary_title" | translate }}</a>
          @if (siteId && jobType) {
            <span aria-hidden="true">/</span>
            <a [routerLink]="['/openjobs', siteId, jobType]" [queryParams]="{ siteName: siteName }">
              {{ siteName || ("open_jobs_summary_unknown_site" | translate) }} - {{ jobTypeKey | translate }} {{ "open_jobs_list_jobs" | translate }}
            </a>
          }
          }
          @if (job) {
            <span aria-hidden="true">/</span>
            <span aria-current="page">{{ "open_job_detail_job_title" | translate: { referenceNumber: job.referenceNumber } }}</span>
          } @else if (isApproval) {
            <span aria-hidden="true">/</span>
            <span aria-current="page">{{ "open_job_detail_job_title" | translate: { referenceNumber: jobId } }}</span>
          }
        </nav>
        <p class="cw-job-head__site">{{ siteName || ("open_jobs_summary_unknown_site" | translate) }}</p>
        <h1 class="cw-page-head__title" id="closedown-title">
          @if (job) {
            {{ "open_job_detail_job_title" | translate: { referenceNumber: job.referenceNumber } }}
          } @else if (isApproval) {
            {{ "open_job_detail_job_title" | translate: { referenceNumber: jobId } }}
          } @else {
            {{ "open_job_detail_job_details" | translate }}
          }
        </h1>
      </div>
      <div class="cw-thinksafe">
        <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
        <span class="cw-thinksafe__link">Browse Health &amp; Safety Documents</span>
      </div>
    </header>

  @if (saveSucceeded) {
    <ng-container *ngTemplateOutlet="updatedBanner"></ng-container>
  } @else if (hasLoadError) {
    <div class="closedown-state closedown-state--error cw-card" role="alert">
      <strong>{{ "open_job_detail_load_failed" | translate }}</strong>
      <span>{{ loadErrorKey | translate }}</span>
    </div>
  } @else if (job || latestClosedown) {
    @if (job?.jobEventClosedown !== null && job?.jobEventClosedown !== undefined && !isApproval) {
      <ng-container *ngTemplateOutlet="updatedBanner"></ng-container>
    } @else {
    @if (job) {
    <div class="cw-job-head">
      <span class="cw-chip">{{ job.jobStatusName }}</span>
    </div>

    <section class="job-summary cw-card" [attr.aria-label]="'open_job_detail_job_details' | translate">
      <div><strong>{{ "open_jobs_list_fault_service" | translate }}</strong><span>{{ job.faultServiceName || ("open_jobs_summary_not_available" | translate) }}</span></div>
      <div><strong>{{ "common_lbl_department" | translate }}</strong><span>{{ job.departmentName || ("open_jobs_summary_not_available" | translate) }}</span></div>
      <div><strong>{{ "open_job_detail_manufacturer" | translate }}</strong><span>{{ job.asset?.manufacturerName || ("open_jobs_summary_not_available" | translate) }}</span></div>
      <div><strong>{{ "open_job_detail_model" | translate }}</strong><span>{{ job.asset?.modelName || ("open_jobs_summary_not_available" | translate) }}</span></div>
      <div><strong>{{ "open_job_detail_serial_number" | translate }}</strong><span>{{ job.asset?.serialNumber || ("open_jobs_summary_not_available" | translate) }}</span></div>
      <div><strong>{{ "open_job_detail_job_notes" | translate }}</strong><span>{{ job.notes || ("open_jobs_summary_not_available" | translate) }}</span></div>
    </section>
    } @else {
    <section class="job-summary cw-card" [attr.aria-label]="'open_job_detail_job_details' | translate">
      <p role="status">{{ "pending_approval_job_metadata_unavailable" | translate }}</p>
    </section>
    }

    @if (isLoadingJobPhotos) {
      <section
        class="job-photos-section"
        [attr.aria-label]="'open_job_detail_photos' | translate">

        <h2>{{ "open_job_detail_photos" | translate }}</h2>

        <div class="job-photos-loading">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </section>
    }
    @else if (uploadedJobPhotos.length > 0) {
      <section
        class="job-photos-section"
        [attr.aria-label]="'open_job_detail_photos' | translate">

        <h2>{{ "open_job_detail_photos" | translate }}</h2>

        <div class="job-photos-list">
          @for (photo of uploadedJobPhotos; track photo.id) {
            <div class="job-photo">
              <img
                class="job-photo-image"
                [src]="'data:image/jpeg;base64,' + photo.thumbnail"
                [alt]="photo.fileName"
                loading="lazy"
                (click)="openPhoto(photo)">

              <div class="job-photo-name">
                {{ photo.fileName }}
              </div>
            </div>
          }
        </div>
      </section>
    }

    @if (selectedPhoto) {
      <div
        class="photo-overlay"
        role="dialog"
        aria-modal="true"
        [attr.aria-label]="selectedPhoto.fileName"
        (click)="closePhoto()">

        <div
          class="photo-overlay-content"
          (click)="$event.stopPropagation()">

          <button
            type="button"
            class="photo-overlay-close"
            aria-label="Close image"
            (click)="closePhoto()">
            <mat-icon>close</mat-icon>
          </button>

          <img
            class="photo-overlay-image"
            [src]="'data:image/jpeg;base64,' + selectedPhoto.base64Content"
            [alt]="selectedPhoto.fileName">

          <div class="photo-overlay-name">
            {{ selectedPhoto.fileName }}
          </div>
        </div>
      </div>
    }

    <div class="closedown-layout" [class.closedown-layout--technician]="!isAdmin">
      @if (isAdmin) {
      <aside class="upgrades cw-card" aria-labelledby="upgrades-title">
        <h2 id="upgrades-title">{{ "open_job_detail_upgrades" | translate }}</h2>
        @if (!purchaseOrder?.id) {
          <p class="upgrade-help">{{ "job_upgrade_error_po_unavailable" | translate }}</p>
        } @else if (canCreateUplift) {
          <p>{{ "open_job_detail_no_upgrades" | translate }}</p>
          <p>{{ "open_job_detail_lodge_upgrade_hint" | translate }}</p>
          <button class="cw-button cw-button--secondary cw-button--block" type="button" (click)="openUpgrade()">
            <mat-icon>add</mat-icon>{{ "open_job_detail_lodge_upgrade" | translate }}
          </button>
        } @else {
          <article class="upgrade-item">
            <div><strong>{{ purchaseOrder?.purchaseOrderNumber || purchaseOrder?.purchaseOrderReferenceId || ("open_job_detail_upgrades" | translate) }}</strong><mat-icon>check</mat-icon></div>
            <span>{{ purchaseOrder?.status || purchaseOrder?.subStatus || ("open_jobs_summary_not_available" | translate) }}</span>
            <span>{{ "open_job_detail_total_amount" | translate: { amount: (purchaseOrder?.amountExcludingTax | currency: (purchaseOrder?.currencyCode || 'AUD')) } }}</span>
          </article>
          <p class="upgrade-help"><mat-icon>info</mat-icon>{{ "open_job_detail_upgrade_help" | translate }}</p>
        }
      </aside>
      }

      <div class="closedown-panels">
        @if (isTechnician) {
          <button class="cw-button cw-button--secondary" type="button" (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>{{ "open_job_detail_return_visit" | translate }}
          </button>
        }
        @if (isTechnician) {
          <section class="technician-allocation cw-card" [formGroup]="technicianAllocationForm" aria-labelledby="allocation-title">
            <h2 id="allocation-title">{{ "open_job_detail_third_party_allocation" | translate }}</h2>
            <div class="technician-allocation__type">
              <label>
                <input type="radio" name="technicianAllocationType" value="internal"
                  [checked]="technicianAllocationType() === 'internal'" disabled>
                {{ "open_jobs_list_internal" | translate }}
              </label>
              <label>
                <input type="radio" name="technicianAllocationType" value="external"
                  [checked]="technicianAllocationType() === 'external'" disabled>
                {{ "open_jobs_list_external" | translate }}
              </label>
            </div>
            <mat-form-field appearance="outline">
              <mat-label>{{ "open_jobs_list_email" | translate }}</mat-label>
              <input matInput type="email" formControlName="email" autocomplete="email">
            </mat-form-field>
            @if (technicianAllocationType() === 'external') {
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_jobs_list_company_name" | translate }}</mat-label>
                <input matInput formControlName="companyName" autocomplete="organization">
              </mat-form-field>
            }
            <div class="field-row">
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_jobs_list_technician_name" | translate }}</mat-label>
                <input matInput formControlName="technicianName" autocomplete="name">
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_jobs_list_phone_number" | translate }}</mat-label>
                <input matInput type="tel" formControlName="phoneNumber" autocomplete="tel">
              </mat-form-field>
            </div>
          </section>
        }
      <form class="closedown-form cw-card" [formGroup]="closedownForm" (ngSubmit)="saveClosedown()" novalidate>
        <h2>{{ "open_job_detail_closedown_information" | translate }}</h2>

        @if (isAdmin) {
        <mat-form-field appearance="outline">
          <mat-label>{{ "open_job_detail_asset_tag" | translate }}</mat-label>
          <input matInput formControlName="assetTag"
            (change)="lookupAssetTag(closedownForm.controls.assetTag.value ?? '', siteId)">
          @if (isAssetTagNotAvailable) {
            <mat-error>{{ "open_job_detail_asset_tag_not_available" | translate }}</mat-error>
          }
        </mat-form-field>
        }

        <mat-form-field appearance="outline">
          <mat-label>{{ "open_job_detail_root_cause" | translate }}</mat-label>
          <mat-select formControlName="rootCause">
            @for (option of rootCauses; track option.id) {
              @if (option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }
            }
          </mat-select>
          <mat-error>{{ "open_job_detail_root_cause_required" | translate }}</mat-error>
        </mat-form-field>

        @if (showGasSection) {
        <mat-checkbox formControlName="gasUsed">{{ "open_job_detail_gas_used" | translate }}</mat-checkbox>
        @if (showGasFields) {
          <div class="field-row field-row--three">
            <mat-form-field appearance="outline"><mat-label>{{ "open_job_detail_gas_type" | translate }}</mat-label><mat-select formControlName="gasType">@for (option of gasTypes; track option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }</mat-select><mat-error>{{ "register_lbl_one_required" | translate }}</mat-error></mat-form-field>
            <mat-form-field appearance="outline"><mat-label>{{ "open_job_detail_gas_usage" | translate }}</mat-label><input matInput type="number" min="0" formControlName="gasUsage"></mat-form-field>
            <mat-form-field appearance="outline"><mat-label>{{ "open_job_detail_gas_leak_type" | translate }}</mat-label><mat-select formControlName="gasLeakType">@for (option of gasLeakTypes; track option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }</mat-select><mat-error>{{ "register_lbl_one_required" | translate }}</mat-error></mat-form-field>
          </div>
        }
        }

        <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>{{ "open_jobs_list_status" | translate }}</mat-label>
          <mat-select formControlName="status">
            @for (option of statuses; track option.id) {
              @if (option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }
            }
          </mat-select>
          <mat-error>{{ "open_job_detail_status_required" | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ "open_job_detail_status_confirmation" | translate }}</mat-label>
          <mat-select formControlName="statusSubType">
            @for (option of affirmations; track option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }
          </mat-select>
          <mat-error>{{ "open_job_detail_status_confirmation_required" | translate }}</mat-error>
        </mat-form-field>
        </div>

        <mat-form-field appearance="outline">
          <mat-label>{{ "open_job_detail_asset_on_departure" | translate }}</mat-label>
          <mat-select formControlName="assetOnDeparture">
            @for (option of assetConditions; track option.id) {
              @if (option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ "open_job_detail_equipment_status" | translate }}</mat-label>
          <mat-select formControlName="equipmentStatus">
            @for (option of equipmentStatuses; track option.id) {
              @if (option.id) { <mat-option [value]="option.id">{{ option.name }}</mat-option> }
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ "open_job_detail_raised_by_ppm" | translate }}</mat-label>
          <mat-select formControlName="isRaisedByPPM"
            [placeholder]="'open_job_detail_select_answer' | translate">
            <mat-option [value]="true">{{ "open_jobs_list_yes" | translate }}</mat-option>
            <mat-option [value]="false">{{ "open_jobs_list_no" | translate }}</mat-option>
          </mat-select>
          <mat-error>{{ "open_job_detail_raised_by_ppm_required" | translate }}</mat-error>
        </mat-form-field>

        @if (showReturnEta) {
          <fieldset>
            <legend>{{ "open_job_detail_revised_eta" | translate }}</legend>
            <div class="field-row field-row--onsite">
              <mat-form-field appearance="outline">
                <mat-label>{{ "open_job_detail_date" | translate }}</mat-label>
                <input matInput readonly [matDatepicker]="returnDatePicker" [min]="minReturnDate" formControlName="returnDate"
                  aria-haspopup="dialog" [attr.aria-expanded]="returnDatePicker.opened"
                  (click)="returnDatePicker.open()"
                  (keydown.enter)="$event.preventDefault(); returnDatePicker.open()"
                  (keydown.space)="$event.preventDefault(); returnDatePicker.open()"
                  (keydown.arrowdown)="$event.preventDefault(); returnDatePicker.open()">
                <span matIconSuffix class="onsite-field-actions">
                  <button mat-button class="onsite-shortcut" type="button" (click)="setReturnDateToToday()">{{ "open_job_detail_today" | translate }}</button>
                  <mat-datepicker-toggle [for]="returnDatePicker"></mat-datepicker-toggle>
                </span>
                <mat-datepicker #returnDatePicker></mat-datepicker>
              </mat-form-field>
              <app-time-picker pickerId="returnTime" label="open_job_detail_time"
                [value]="closedownForm.controls.returnTime.value"
                [minuteStep]="durationMinuteInterval" [showNowButton]="true"
                (timeChange)="applyTime('returnTime', $event)" (nowClicked)="setReturnTimeToNow()"></app-time-picker>
            </div>
          </fieldset>
        }

        <mat-form-field appearance="outline">
          <mat-label>{{ "open_jobs_list_notes" | translate }}</mat-label>
          <textarea matInput rows="3" formControlName="notes"></textarea>
        </mat-form-field>

        <fieldset>
          <legend>{{ "open_job_detail_onsite" | translate }}</legend>
          <div class="field-row field-row--onsite">
            <mat-form-field appearance="outline">
              <mat-label>{{ "open_job_detail_date" | translate }}</mat-label>
              <input matInput readonly [matDatepicker]="onsiteDatePicker" [max]="maxOnsiteDate" formControlName="onsiteDate"
                aria-haspopup="dialog" [attr.aria-expanded]="onsiteDatePicker.opened"
                (click)="onsiteDatePicker.open()"
                (keydown.enter)="$event.preventDefault(); onsiteDatePicker.open()"
                (keydown.space)="$event.preventDefault(); onsiteDatePicker.open()"
                (keydown.arrowdown)="$event.preventDefault(); onsiteDatePicker.open()">
              <span matIconSuffix class="onsite-field-actions">
                <button mat-button class="onsite-shortcut" type="button" (click)="setOnsiteDateToToday()">{{ "open_job_detail_today" | translate }}</button>
                <mat-datepicker-toggle [for]="onsiteDatePicker"></mat-datepicker-toggle>
              </span>
              <mat-datepicker #onsiteDatePicker></mat-datepicker>
            </mat-form-field>
            <app-time-picker pickerId="onsiteTime" label="open_job_detail_time"
              [value]="closedownForm.controls.onsiteTime.value"
              [minuteStep]="durationMinuteInterval" [showNowButton]="true"
              (timeChange)="applyTime('onsiteTime', $event)" (nowClicked)="setOnsiteTimeToNow()"></app-time-picker>
          </div>
        </fieldset>

        <div class="field-row duration-fields">
          @for (field of durationFields; track field.control) {
            <app-time-picker [pickerId]="field.control" [label]="field.label"
              [value]="closedownForm.controls[field.control].value"
              [minuteStep]="durationMinuteInterval" displayFormat="24-hour"
              [showError]="closedownForm.controls[field.control].invalid && closedownForm.controls[field.control].touched"
              [errorMessage]="field.label"
              (timeChange)="applyTime(field.control, $event)"></app-time-picker>
          }
        </div>

        @if (!isApproval) {
        <section class="uploads" [attr.aria-label]="'open_job_detail_attachments' | translate">
          @if (enableJobPhotos()) 
          {
            <ng-container *ngTemplateOutlet="fileQueue; context: { label: 'open_job_detail_upload_photos', type: 'photo', files: photos, accept: 'image/*' }"></ng-container>
          }
          @if (showSupportingDocuments()) 
          {
            <ng-container *ngTemplateOutlet="fileQueue; context: { label: 'open_job_detail_upload_supporting_documents', type: 'supporting-document', files: supportingDocuments, accept: '.pdf,.doc,.docx,.xls,.xlsx,image/*' }"></ng-container>
          }
          @if (showServiceSheets()) 
          {
            <ng-container *ngTemplateOutlet="fileQueue; context: { label: 'open_job_detail_upload_service_sheets', type: 'service-sheet', files: serviceSheets, accept: '.pdf,.doc,.docx,image/*' }"></ng-container>
          }
          @if (fileErrorKey) { <div class="form-message form-message--error" role="alert">{{ fileErrorKey | translate: fileErrorParams }}</div> }
        </section>
        }

        @if (saveErrorKey) {
          <div class="form-message form-message--error" role="alert">
            <div class="form-message__header">
              <strong>{{ "open_job_detail_failed_title" | translate }}</strong>
              <button mat-icon-button type="button" (click)="clearError()" [attr.aria-label]="'open_job_detail_dismiss' | translate">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <p>{{ saveErrorKey | translate }}</p>
            @if (saveErrorMessage) { <p>{{ saveErrorMessage }}</p> }
          </div>
        }
        <div class="form-actions">
          <button class="cw-button cw-button--primary cw-button--save" type="submit" [disabled]="isSaving || isAssetTagNotAvailable">
            <mat-icon>check</mat-icon>            {{ (isSaving
              ? (isApproval ? 'open_job_detail_approving' : 'open_job_detail_saving')
              : (isApproval ? 'open_job_detail_approve_closedown' : 'open_job_detail_save')) | translate }}
          </button>
        </div>
      </form>
      </div>
    </div>
    }
  } @else {
    <div role="status" [attr.aria-label]="'signin_lbl_loading_jobs' | translate">
      <div aria-hidden="true">
        <app-skeleton height="140px"></app-skeleton>
        <div class="closedown-layout">
          <app-skeleton height="200px"></app-skeleton>
          <app-skeleton height="480px"></app-skeleton>
        </div>
      </div>
    </div>
  }
  </main>
  <app-workbench-footer></app-workbench-footer>
</div>

<ng-template #updatedBanner>
  <div class="job-updated-banner" [class.job-updated-banner--pending]="updateState() === 'pending'" role="status">
    @if (updateState() === 'pending') {
      <mat-progress-bar class="job-updated-banner__progress" mode="indeterminate"
        [attr.aria-label]="'open_job_detail_job_updating' | translate"></mat-progress-bar>
      <strong>{{ 'open_job_detail_job_updating' | translate }}</strong>
      <p class="job-updated-banner__description">{{ 'open_job_detail_job_processing_description' | translate }}</p>
      @if (updateCheckFailed()) {
        <p class="job-update-error" role="alert">{{ 'open_job_detail_update_check_failed' | translate }}</p>
      }
      <button mat-stroked-button type="button" class="job-updated-banner__return" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>{{ (isTechnician ? 'open_job_detail_return_visit' : 'open_job_detail_return_job_list') | translate }}
      </button>
    } @else {
      <mat-icon aria-hidden="true">check_circle</mat-icon>
      <strong>{{ 'open_job_detail_job_updated' | translate }}</strong>
      <ng-container *ngTemplateOutlet="nextActions"></ng-container>
    }
  </div>
</ng-template>

<ng-template #nextActions>
  <div class="next-actions">
    <strong>{{ "open_job_detail_next_actions" | translate }}</strong>
    @if (isTechnician) {
      <button mat-stroked-button type="button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>{{ "open_job_detail_return_visit" | translate }}
      </button>
    } @else if (isApproval) {
    <button mat-stroked-button type="button" class="next-actions__home" routerLink="/dashboard">
      <mat-icon>home</mat-icon>{{ "open_job_detail_return_home" | translate }}
    </button>
    <button mat-stroked-button type="button" class="next-actions__job-list" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>{{ "open_job_detail_return_job_list" | translate }}
    </button>
    } @else {
    <button mat-stroked-button type="button" class="next-actions__home" routerLink="/dashboard">
      <mat-icon>home</mat-icon>{{ "open_job_detail_return_home" | translate }}
    </button>
    <button mat-stroked-button type="button" class="next-actions__job-list" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>{{ "open_job_detail_return_job_list" | translate }}
    </button>
    <button mat-raised-button type="button" class="next-actions__invoice">
      <mat-icon>receipt_long</mat-icon>{{ "open_job_detail_submit_invoice" | translate }}
    </button>
    }
  </div>
</ng-template>

<ng-template #fileQueue let-label="label" let-type="type" let-files="files" let-accept="accept">
  <div class="upload-row">
    <div class="upload-header">
      <h3>{{ label | translate }}</h3>
      <label class="upload-button" (click)="onAddFileClick($event, type)">
        <mat-icon aria-hidden="true">add</mat-icon>
        {{ (type === 'photo' ? 'open_job_detail_add_photo' : 'open_job_detail_add_file') | translate }}

        <input
          type="file"
          multiple
          [accept]="accept"
          (change)="selectFiles($event, type)"
          [attr.aria-label]="
            ((type === 'photo' ? 'open_job_detail_add_photo' : 'open_job_detail_add_file') | translate)
            + ': ' + (label | translate)
          ">
      </label>
    </div>
    @for (item of files; track item.file.name + $index) {
      <div class="upload-file" [class.upload-file--photo]="type === 'photo'">
        <mat-icon class="upload-file__icon" aria-hidden="true">{{ type === 'photo' ? 'image' : 'insert_drive_file' }}</mat-icon>
        <span class="upload-file__name">{{ item.file.name }}</span>
        @if (type === 'photo') {
          <select [(ngModel)]="item.reason" [ngModelOptions]="{ standalone: true }" [attr.aria-label]="'open_job_detail_photo_reason' | translate">
            <option value="">{{ "open_job_detail_select_reason" | translate }}</option>
            @for (reason of photoReasonsDisplay; track reason) { <option [value]="reason">{{ reason }}</option> }
          </select>
        }
        <button mat-icon-button class="upload-file__remove" type="button" (click)="removeFile(item)" [attr.aria-label]="('open_job_detail_remove_file' | translate) + ': ' + item.file.name"><mat-icon>delete</mat-icon></button>
      </div>
    }
    @if (type === 'supporting-document' && files.length > 0) {
      <div class="upload-info">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>{{ "open_job_detail_upload_supporting_documents_invoice_reminder" | translate }}</span>
      </div>
    }

    @if (type === 'service-sheet' && files.length > 0) {
      <div class="upload-info">
        <mat-icon aria-hidden="true">info</mat-icon>
        <span>{{ "open_job_detail_upload_service_sheets_invoice_reminder" | translate }}</span>
      </div>
    }
  </div>
</ng-template>